

















import { content } from '@/constants/commonContent';
import { Base } from '@/base';
import Component from 'vue-class-component';

@Component({
  name: 'AccessDeniedPage'
})
export default class AccessDeniedPage extends Base {
  defaultInfo = content.infoDeniedMemberObj;
  info() {
    if (!this.getConnectedStatus) return content.infoNoConnectedObj;
    if (this.isWaiting()) return content.infoDeniedWaitingObj;
    if (this.isMember()) return content.infoOnlyOwnersObj;
    return this.defaultInfo;
  }
}
